import React from 'react';
import { Redirect } from 'react-router-dom';
import { ArcRoutes } from '../../../pages/arc/constants/routes';
import { isDioAdmin, isInstitutionOfficer } from '../../helpers/auth-helpers';
import { useBasePath } from '../../hooks/useBasePath';

export const withGroupAdminRights = () => (WrappedComponent: React.ComponentType<any>) => {
	return (props: React.PropsWithChildren<any>) => {
		const isDiocesan = isDioAdmin();
		const isSeniorOfficer = isInstitutionOfficer();

		if (!isDiocesan && !isSeniorOfficer) {
			return <Redirect to={useBasePath(ArcRoutes.ArcRoot)} />;

		}
		return (<WrappedComponent {...props}>
			{props.children}
		</WrappedComponent>);

	};
};
